// extracted by mini-css-extract-plugin
export default {"link":"MailTo_link__gvPVW"};